import axios from "axios";
let moment = require("moment");
let md5 = require("md5");
const state = {
  selected: {},
  headers: [
    { text: "Vencimento", value: "datavencimento", sortable: false },
    { text: "Valor", value: "valordocumento", sortable: false },
    { text: "Documento", value: "id", sortable: false },
    { text: "Código de Barras", value: "situacao", sortable: false },
    { text: "Boleto", value: "referencia", sortable: false }
  ],
  bankSlipsList: []
}
const actions = {
  allBankSlip: ({ }, plans) => plans.map((e) => e.fichafinanceira).reduce((acum, x) => acum.concat(x), []),
  getAllOpened: async ({ dispatch }, plans) => {
    let allBankSlip = await dispatch('allBankSlip', plans)
    return allBankSlip.filter(bankSlip => bankSlip.situacao != 'Pago')
  },
  getAllPayments: async ({ dispatch }, plans) => {
    let allBankSlip = await dispatch('allBankSlip', plans)
    return allBankSlip.filter(bankSlip => bankSlip.situacao == 'Pago')
  },
  showAlertPayment: async ({ dispatch }, plans) => {
    let allBankSlip = await dispatch('getAllOpened', plans)
    let hasExpiredSlip = allBankSlip.findIndex(e => new Date(e.datavencimento) < new Date().getTime())
    return hasExpiredSlip > -1
  },
  async getBankSlipsByCPF({ commit, dispatch }, cpf) {

    let _this = this
    let bankSlipsList = []
    let listWithDigiline = []
    let obj = {
      url: '/corpore/wscorp.dll/datasnap/rest/tsmadesao/cobrancas',
      query: { cpf: cpf, },
      method: 'post'
    }
    let PIN =
      "PN" +
      cpf.replace(/\D/g, "") +
      "@" +
      moment(new Date()).format("YYYYMMDD");
    localStorage.alltechPIN = md5(PIN);
    await _this.dispatch('request/doRequest', obj).then(bankSlips => {
      bankSlipsList = bankSlips.data.cobrancas
      console.log('resp cobranca')
      if (bankSlips.data.quantidade == 0) {
        let paramModal = {}
        paramModal.message = "Não há boletos em aberto para este CPF"
        paramModal.title = 'Atenção'
        paramModal.type = 'warning'
        // paramModal.callback = () => { _this.dispatch('request/logout') }
        paramModal.btConfirm = {
          name: 'Ok',
          show: true
        }
        paramModal.btCancel = {
          show: false
        }
        _this.commit('confirmMessage/showConfirmMessage', paramModal)
      }
      return bankSlipsList
    }).then(async bankSlipsList => {
      await dispatch('getDigiline', bankSlipsList).then(newList => {
        listWithDigiline = newList
        return listWithDigiline
      })
    })
    return listWithDigiline
  },
  async getDigiline({ state }, bankSlipsList) {
    if (!bankSlipsList) {
      return []
    }
    let _this = this
    let newList = []
    for (var bankSlip in bankSlipsList) {
      let newData = {}
      let obj = {
        url: '/corpore/wscorp.dll/datasnap/rest/tsmboletos/boleto',
        query: {
          // cpf: localStorage.corporeUserId,
          cpf: bankSlipsList[bankSlip].cpfTitular,
          codigocobranca: (bankSlipsList[bankSlip].codigo || bankSlipsList[bankSlip].id)
        },
        method: 'post'
      }
      await _this.dispatch('request/doRequest', obj).then(resp => {
        newData = {
          linhaDigitavel: resp.data.linhaDigitavel,
          mensagem: resp.data.mensagem ? resp.data.mensagem : ''
        }
        newList.push({ ...bankSlipsList[bankSlip], ...newData })
        return newData
      })
    }
    return newList
  }
}
const mutations = {
  setSelected(state, bankslip) {
    state.selected = bankslip;
  },
  saveList(state, newList) {
    state.bankSlipsList = newList;
  },
}


export default {
  namespaced: true,
  root: true,
  state,
  mutations,
  actions
}